import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { AuthProvider } from './auth/AuthContext'
import { RequireAuth } from './auth/RequireAuth'
import { SetupRequired } from './components/SetupRequired'
import { isSupabaseConfigured } from './lib/config'
import { AccountPage } from './pages/AccountPage'
import { AgreementsPage } from './pages/AgreementsPage'
import { BillingPage } from './pages/BillingPage'
import { DownloadsPage } from './pages/DownloadsPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { HomePage } from './pages/HomePage'
import { LoginPage } from './pages/LoginPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { SignUpPage } from './pages/SignUpPage'

export function App() {
  // No env -> setup screen (never crash into a white screen).
  if (!isSupabaseConfigured()) return <SetupRequired />

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public auth screens */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />

          {/* Authenticated area (RequireAuth → app shell) */}
          <Route element={<RequireAuth />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/downloads" element={<DownloadsPage />} />
            <Route path="/agreements" element={<AgreementsPage />} />
            <Route path="/billing" element={<BillingPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
